import React from 'react';
import SharedTranslations, { TranslationField } from "shared/components/Translations";
import { LocaleCode } from "shared/types/languages";
import TranslationInput from "shared/components/Translations/TranslationInput";
import { useBulletinDetails } from "../../context";
import { ManagedTranslations } from "modules/bulletinBoard/context/types";

const Translations = () => {
  const { bulletinTitle, bulletinDescription, translations, setTranslations } = useBulletinDetails();

  const fields: TranslationField[] = [
    {
      key: ManagedTranslations.Title,
      label: "Title",
      render: ({ language, value, onChange }) => (
        <TranslationInput
          defaultValue={language === LocaleCode.en ? bulletinTitle?.input.value : value}
          variant="filled"
          onChange={({ target: { value } }) => {
            if (language === LocaleCode.en) {
              bulletinTitle?.setValue(value);
            } else {
              onChange(value);
            }
          }}
        />
      ),
    },
    {
      key: ManagedTranslations.Description,
      label: "Description",
      render: ({ language, value, onChange }) => (
        <TranslationInput
          defaultValue={language === LocaleCode.en ? bulletinDescription?.input.value : value}
          variant="filled"
          onChange={({ target: { value } }) => {
            if (language === LocaleCode.en) {
              bulletinDescription?.setValue(value);
            } else {
              onChange(value);
            }
          }}
        />
      ),
    },
  ];

  return (
    <SharedTranslations
      fields={fields}
      translations={translations}
      setTranslations={setTranslations}
    />
  );
};

export default Translations;
